import { GRID_SLUG, SECTION_SLUG } from "@/lib/elements/constants";
import { findNodeParent } from "@/lib/tree/tree";
import { documentStore } from "@/store/store";
import { TreeNode } from "@/types/tree";

export function isDragAllowedForElement(_element: TreeNode) {

    return false;

    // if (element.data.type === SECTION_SLUG) {
    //     return true;
    // }

    // if (isElementInLikeKindGrid(element)) {
    //     return true;
    // }
}

function isElementInLikeKindGrid(element: TreeNode) {

    const nodeParent = findNodeParent(documentStore.document.tree, element);
    if (!nodeParent) {
        return false;
    }

    if (nodeParent.data.type !== GRID_SLUG) {
        return false;
    }

    const allChildrenHaveSameType = nodeParent.children.every(child => child.data.type === element.data.type);

    if (!allChildrenHaveSameType) {
        return false;
    }

    return true;
}